import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, computed, DestroyRef, inject, input, OnInit, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Crop, getCrops } from '@next/arable-lib/crop';
import { CropField } from '@next/arable-lib/crop-field';
import { Store } from '@ngrx/store';
import { TgaSharedService } from 'src/app/tga/shared/services/tga-shared.service';
import { DecimalPipe } from '@angular/common';
import { CropYearSelectorComponent } from '../../../../../shared/components/crop-year-selector/crop-year-selector.component';

@Component({
    selector: 'specific-form-header-section',
    templateUrl: './specific-form-header-section.component.html',
    styleUrl: './specific-form-header-section.component.scss',
    imports: [DecimalPipe, CropYearSelectorComponent],
})
export class SpecificFormHeaderSectionComponent implements OnInit {
  private readonly breakpointObserver = inject(BreakpointObserver);
  private readonly tgaSharedService = inject(TgaSharedService);
  private readonly store = inject(Store);

  private readonly destroyRef = inject(DestroyRef);
  title = input.required<string>();
  cropField = input<CropField>();
  cropYear = input.required<number | null>();

  readonly cropFieldName = computed(() => this.cropField()?.name || '');
  readonly cropFieldArea = computed(() => this.cropField()?.areaInHectares || 0);
  readonly cropFieldEndYear = computed(() => this.getEndDateYear(this.cropField()) || null);
  readonly cropFieldCrop = computed(() => this.getCropName(this.cropField()?.cropId) || '');
  readonly isMobileOrTablet = signal<boolean>(false);

  readonly crops$ = this.store.select(getCrops);
  private crops: Crop[] = [];

  constructor() {
    this.breakpointObserver
      .observe([Breakpoints.Handset, Breakpoints.Tablet])
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((result) => {
        this.isMobileOrTablet.set(result.matches);
      });
  }

  ngOnInit(): void {
    this.crops$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((crops) => {
      this.crops = crops || [];
    });
  }

  getEndDateYear(cropField?: CropField): number | null {
    if (!cropField) return this.cropYear();
    return this.tgaSharedService.getEndDateYear(cropField, this.cropYear() || new Date().getFullYear());
  }

  getCropName(cropId?: number): string {
    return this.tgaSharedService.getCropName(cropId, this.crops);
  }
}
